import { render } from "./TikTokInsights.vue?vue&type=template&id=31c40a69&scoped=true"
import script from "./TikTokInsights.vue?vue&type=script&lang=js"
export * from "./TikTokInsights.vue?vue&type=script&lang=js"

import "./TikTokInsights.vue?vue&type=style&index=0&id=31c40a69&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c40a69"]])

export default __exports__